import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

const BASE = '/admin/city'

const crud = (path) => ({
	list: (params = {}) => Http.get(`${BASE}/${path}${serialize(params)}`),
	get: (id) => Http.get(`${BASE}/${path}/${id}`),
	save: (params) => Http.post(`${BASE}/${path}`, params),
	update: (id, params) => Http.put(`${BASE}/${path}/${id}`, params),
	remove: (id) => Http.delete(`${BASE}/${path}/${id}`),
})

export const cityApi = {
	districts: crud('districts'),
	npcs: crud('npcs'),
	features: crud('features'),
	missions: crud('missions'),
	coinSpawns: crud('coin-spawns'),
	easterEggs: crud('easter-eggs'),
	seasonalEvents: crud('seasonal-events'),
	profiles: crud('profiles'),
	dialogues: crud('dialogues'),

	// City Text Manager — flat list of every translatable string (read-only list;
	// writes go through updateCityText, keyed by model+attribute+locale).
	texts: { list: (params = {}) => Http.get(`${BASE}/texts${serialize(params)}`) },
}

// Upsert one string: {model_type, model_id, attribute, locale, value}
export const updateCityText = (params) => Http.put(`${BASE}/texts`, params)

// Settings (manual marketing stats + Discord URL) — flat GET/PUT, no resource id
export const getCitySettings = () => Http.get(`${BASE}/settings`)
export const updateCitySettings = (settings) => Http.put(`${BASE}/settings`, { settings })

// Dialogue tree (whole-tree diff-sync, nodes keyed by node_key)
export const getDialogueTree = (id) => Http.get(`${BASE}/dialogues/${id}/tree`)
export const saveDialogueTree = (id, nodes) => Http.put(`${BASE}/dialogues/${id}/tree`, { nodes })

// Analytics
export const getCityAnalyticsOverview = (params = {}) => Http.get(`${BASE}/analytics/overview${serialize(params)}`)
export const getCityAnalyticsFunnel = (params = {}) => Http.get(`${BASE}/analytics/funnel${serialize(params)}`)
export const getCityAnalyticsDistricts = (params = {}) => Http.get(`${BASE}/analytics/districts${serialize(params)}`)
export const getCityAnalyticsCta = (params = {}) => Http.get(`${BASE}/analytics/cta${serialize(params)}`)
